import type { Author, AuthorStats, Course, KursFerdigHendelse } from '@/data/types';

export function applyBoosts(stats: AuthorStats, boosts: Partial<AuthorStats>): AuthorStats {
  const ut: AuthorStats = { ...stats };
  for (const [k, v] of Object.entries(boosts)) {
    const key = k as keyof AuthorStats;
    if (v === undefined) continue;
    const ny = (ut[key] ?? 0) + v;
    ut[key] = Math.max(0, Math.min(100, ny));
  }
  return ut;
}

export function lagKursHendelse(
  forfatter: Author,
  kurs: Course,
  boostsApplisert: Partial<AuthorStats>,
): KursFerdigHendelse {
  return {
    authorId: forfatter.id,
    forfatterNavn: forfatter.navn,
    kursId: kurs.id,
    kursTittel: kurs.title,
    kursUrl: kurs.url,
    boosts: { ...boostsApplisert },
  };
}
